import React, { useState } from "react";
import cx from "classnames";
import { withTranslation } from "react-i18next";

import {
    Button,
    UncontrolledPopover,
    PopoverBody,
} from "reactstrap";

function RenderPopfirm(props) {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <React.Fragment>
            <div color={props.type} id={"PopoverCustom-" + props.id} onClick={() => { setIsOpen(true) }} >
                {props.children}
            </div>
            <UncontrolledPopover isOpen={isOpen} className="popover-custom" placement={props.placement} trigger="legacy" target={"PopoverCustom-" + props.id}
                fade={true} >
                <PopoverBody>
                    <div style={{ width: 250, height: 200 }}>
                        <div >
                            <div
                                className={cx(
                                    "dropdown-menu-header-inner bg-" + props.type
                                )}>
                                <div className="menu-header-content" >
                                    <h5 style={{ color: 'white', fontWeight: 'bold', textAlign: 'center', padding: 5 }}>{props.title}</h5>

                                </div>
                            </div>
                        </div>

                        <div style={{ height: 110, display: 'flex', textAlign:'center', justifyContent: 'center', 
                        alignItems: 'center' ,padding:"0px 10px"}} >
                            {props.content}
                        </div>

                        <div style={{ borderTop: '1px solid rgb(190,190,190)' }} />
                        <div style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center',marginTop:10 }}>
                            <Button size="sm" className="btn-wide btn-shadow" color="primary" onClick={()=>{props.onOK() ; setIsOpen(false) } }>
                                {props.t("Yes")}
                        </Button>
                            <Button size="sm" className="btn-wide btn-shadow" color="danger" onClick={() => { setIsOpen(false) }}>
                            {props.t("No")}
                        </Button>
                        </div>
                    </div>
                </PopoverBody>
            </UncontrolledPopover >
        </React.Fragment>
    );
}


export default withTranslation(["dashboard"])(RenderPopfirm);